import { ComponentType, useEffect } from 'react';
import {
  RouteComponentProps,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';
import { useDatasetContext } from '../hooks/context/useDatasetContext';
import { getSubsetAndItemParams } from '../utils/getSubsetAndItemParams';
import { GlobalLocationStateType } from '../types/types';

const withDatasetScope = <P extends RouteComponentProps>(
  Component: ComponentType<P>
) => {
  const WithDatasetScopeWrapper = (props: P) => {
    const params = useParams<{ datasetId: string }>();
    const history = useHistory();
    const location = useLocation<GlobalLocationStateType>();
    const { setDatasetId, setSubsetId } = useDatasetContext();

    useEffect(() => {
      setDatasetId(params.datasetId);
    }, [params.datasetId]);

    /* Subset is not registered as proper route, so it need to be listened manually */
    useEffect(() => {
      const { subsetId } = getSubsetAndItemParams(location.pathname);
      setSubsetId(subsetId);
    }, [location, history]);

    return <Component {...props} />;
  };

  return WithDatasetScopeWrapper;
};

export default withDatasetScope;
